module.exports = __webpack_public_path__ + "static/media/giftcard_icon.3fa28672.svg";